module.exports = __webpack_public_path__ + "static/media/waiting.20b6bad3.gif";